import { useEffect, useState } from 'react';

// Light/dark theme. The choice lives on <html data-theme> and in localStorage;
// index.html applies it before first paint so there is no flash.
const STORAGE_KEY = 'nbTheme';
const listeners = new Set();

export function getTheme() {
  return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
}

export function setTheme(theme) {
  const root = document.documentElement;
  root.classList.add('nb-theme-switching');
  root.setAttribute('data-theme', theme);
  try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* storage unavailable */ }
  window.setTimeout(() => root.classList.remove('nb-theme-switching'), 400);
  listeners.forEach((fn) => fn(theme));
}

export function toggleTheme() {
  setTheme(getTheme() === 'dark' ? 'light' : 'dark');
}

export function useTheme() {
  const [theme, setState] = useState(getTheme);
  useEffect(() => {
    listeners.add(setState);
    return () => listeners.delete(setState);
  }, []);
  return [theme, setTheme];
}
